import * as d3 from 'd3';
import React, { useEffect } from 'react';
import havana from '../../../../data/havana.js';

function CodingVariants (props) {

    const slot = props.slot,
        pos = props.pos,
        size = props.size,
        interval = [props.locus.low, props.locus.high],
        settings = props.settings,
        codV = props.codV,
        elements = props.elements,
        scalePosition = props.scalePosition;

    const positions = elements.map(el => +el[pos])
    const data = codV[slot.chr-1][1].filter(item => positions.includes(+item.pos))

    const y = size.margin.top-7
    const corner1 = 0 + ',' + y,
        corner2 = 4 + ',' + (y-6),
        corner3 = -4 + ',' + (y-6);
    const triangle =  corner1 + ' ' + corner2 + ' ' + corner3;

    function colorVariants (position) {
        if (interval[0] === undefined) return settings.blue2
        else if (interval[1] < position || interval[0] > position) return settings.blue2
        else return settings.white
    }
    
    useEffect(()=>{
        d3.select('#codingVariants02').selectAll('.unit').data(data, d => d.pos).join(
            function(enter){
                enter.append('polygon')
                    .attr('class', 'unit')
                    .attr('points', triangle)
                    .style('transform', d => `translateX(${(scalePosition(d.pos))}px)`)
                    .attr('fill', d => colorVariants(d.pos))
                    .style('opacity', 0)
                    .transition().duration(500)
                        .style('opacity', 1)

            },
            function(update){
                update.transition().duration(500)
                    .style('transform', d => `translateX(${(scalePosition(d.pos))}px)`)
                    .attr('fill', d => colorVariants(d.pos))
            },
            function(exit){
                exit.transition().duration(500)
                    .style('opacity', 0)
                    .transition().duration(500).remove()
            }
        )

    })

    return (
        <g id='codingVariants02'>
            {/* <rect id='genes_background'
                x={size.margin.left}
                y={size.margin.top}
                width={size.width-size.margin.left}
                height={size.genes}
                fill = {settings.blue1}
                style ={{opacity: 0.1}}
                />
            <g id='genes_arrows'></g> */}
        </g>
    )
    
}
export default CodingVariants;